/**
 * @fileoverview POST handler for the "/dashboard/async_request_manager/cancel_request" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { dashboardAsyncRequestManagerCancelRequestCacheKeys } from "./constants";
import type {
  PostDashboardAsyncRequestManagerCancelRequestProps,
  AsyncRequestManagerCancelRequestResult,
} from "./types";

export const postAsyncRequestManagerCancelRequest = reactQueryMutationAdapter(
  dashboardAsyncRequestManagerCancelRequestCacheKeys,
  (props: PostDashboardAsyncRequestManagerCancelRequestProps): Promise<AsyncRequestManagerCancelRequestResult> => {
    return fetch("/dashboard/async_request_manager/cancel_request", "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
